module.exports = __webpack_public_path__ + "img/11.5cae9cd6.png";